<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">繁星计划</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>新人信息</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <list @refresh="getList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import List from './components/list';

export default {
  name: 'foundationRecords',
  data() {
    return {};
  },
  components: {
    List
  },
  computed: {
    ...mapState('newpeople', ['pagination', 'records'])
  },
  methods: {
    ...mapActions('newpeople', ['getRecords']),
    handleSearch() {
      this.getList();
    },
    getList(data = {}) {
      this.getRecords({
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>
